import React, { Component, PropTypes } from 'react'
import { Button } from "react-bootstrap";

require(`../assets/${process.env.PAGE}/css/components/WhatsappButton.css`)

class Whatsapp extends Component {

  static propTypes = {
    phone: PropTypes.string,
    text: PropTypes.string
  };

  WALink() {
    const {phone, text} = this.props;
    return 'https://api.whatsapp.com/send?phone=' + phone + '&text=' + text;
  }

  render() {
    return (
      <div className="fixed-wp-div">
        <Button className="nextButton d-flex justify-content-center border-0 bg-transparent btn-primary">
          <a href={this.WALink()} className="whatsapp" rel="noreferrer" target="blank"><i className="fa fa-whatsapp whatsapp-icon"/></a>
        </Button>
      </div>
    )
  }
}

export default Whatsapp;


/** WEBPACK FOOTER **
 ** ./src/components/WhatsappButton.js
 **/